export const BeConfig = {
  baseUrl: process.env.NEXT_PUBLIC_BORROWER_EXPERIENCE_BASE_URL || 'https://localhost:3000',
}
